import { ModalType } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI, Value } from '@philips-emr/tws-core';
import { Changeable, ChangeEventListener, Focusable, FocusEventListener } from '@philips-emr/tws-core/lib/component/types';
import { isEnumValid } from '@philips-emr/tws-utils';

class LocatorAPI extends ComponentAPI implements Changeable<Record<string, Value>>, Focusable {
  
  /** @event */
  @AwesomeEvent
  onBlur = new FocusEventListener();

  /** @event */
  @AwesomeEvent
  onFocus = new FocusEventListener();

  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<Record<string, Value>>();

  getData(): Record<string, Value>[] {
    return this.state.data;
  }

  setData(data: Record<string, Value>[]): void {
    this.setState({ data });
  }

  isEnabled(): boolean {
    return this.state.enabled;
  }

  setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  getFragment(): string {
    return this.state.fragment;
  }

  setFragment(fragment: string): void {
    this.setState({ fragment });
  }

  isInputEnabled(): boolean {
    return this.state.inputEnabled;
  }

  setInputEnabled(inputEnabled: boolean): void {
    this.setState({ inputEnabled });
  }

  getModalType(): ModalType {
    return this.state.type;
  }

  setModalType(type: ModalType): void {
    if (isEnumValid(ModalType, type)) {
      this.setState({ type });
    }
  }

  getDisplayProp(): string {
    return this.state.displayProp;
  }

  setDisplayProp(displayProp: string): void {
    this.setState({ displayProp });
  }

  getPlaceholder(): string {
    return this.state.placeholder;
  }

  setPlaceholder(placeholder: string): void {
    this.setState({ placeholder });
  }

  isReadOnly(): boolean {
    return this.state.readOnly;
  }

  setReadOnly(readOnly: boolean): void {
    this.setState({ readOnly });
  }

  getValue(): Record<string, Value> {
    return this.state.value;
  }

  setValue(value: Record<string, Value>): void {
    this.setState({ value });
  }

}

export default LocatorAPI;
